export enum ContentAssetID {
    BRANDS_A_E = 'brands-A-to-E',
    BRANDS_F_J = 'brands-F-to-J',
    BRANDS_K_O = 'brands-K-to-O',
    BRANDS_P_T = 'brands-P-to-T',
    BRANDS_U_123 = 'brands-U-to-123',
    PRODUCT_SHIPPING_RETURNS = 'product-shipping-and-returns',
    CART_IN_STORE_CULINARY_POLICY = 'class-instore-attendee-cancellation-policy',
    CART_ONLINE_CULINARY_POLICY = 'attendee-cancellation-policy',
}
